import React from "react";
import { useEffect } from "react";
import { HeroA } from "../components/home-a/HeroA";
import { TrustedBy } from "../components/home-a/TrustedBy";
import { Services } from "../components/home-a/Services";
import { Stats } from "../components/home-a/Stats";
import { DNSPreview } from "../components/home-a/DNSPreview";
import { Testimonials } from "../components/home-a/Testimonials";
import { Pricing } from "../components/home-a/Pricing";
import { FAQ } from "../components/home-a/FAQ";
import { CTABand } from "../components/home-a/CTABand";
import { toast } from "sonner";

export default function HomeA({ onAddToCart }) {
    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            setTimeout(() => {
                document.querySelector(hash)?.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }, 100);
        }
    }, []);

    const handleAdd = (domain) => {
        onAddToCart?.(domain);
        toast.success(`Added ${domain.domain} to cart`);
    };

    return (
        <main data-testid="home-a-page" className="bg-limestone-100">
            <HeroA onAddToCart={handleAdd} />
            <TrustedBy />
            <Services />
            <Stats />
            <DNSPreview />
            <Pricing />
            <Testimonials />
            <FAQ />
            <CTABand />
        </main>
    );
}
